import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { JobDashboardService } from './job-dashboard.service';
import { JobDashboardConfiguration } from './job-dashboard-configuration';
import { RouterLink } from '@angular/router';
import { CardBarComponent } from '../../../../components/card-bar/card-bar.component';
import { AuthorizationService } from '@nimmsta/ng-commons-lib/auth';
import { LoadingIndicatorComponent } from '@nimmsta/ng-commons-lib/loading-indicator';
import { CardDataItem } from '../../../../models/cardDataItem';
import { DashboardComponentInterface } from '../../../../models/dashboard';
import { STATUS_WIDGET_REFRESH_INTERVAL_MS } from '../status-widget-refresh.constants';

@Component({
  selector: 'app-job-dashboard',
  templateUrl: './job-dashboard.component.html',
  imports: [RouterLink, LoadingIndicatorComponent, CardBarComponent],
})
export class JobDashboardComponent
  implements OnInit, OnDestroy, DashboardComponentInterface
{
  private authorizationService = inject(AuthorizationService);
  private jobDashboardService = inject(JobDashboardService);
  @Input() configuration!: JobDashboardConfiguration;

  readonly intervalTime = STATUS_WIDGET_REFRESH_INTERVAL_MS;

  protected jobData: CardDataItem[] = [new CardDataItem('Loading', 0)];

  protected isLoading = false;

  protected canNavigateToJobs =
    this.authorizationService.hasPermission('job.read');

  private interval?: ReturnType<typeof setInterval> = undefined;

  private isFirstLoad = true;

  ngOnInit() {
    this.interval = setInterval(() => this.loadData(), this.intervalTime);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  setConfiguration(configuration: unknown): void {
    this.configuration = {
      ...this.configuration,
      ...(configuration as object),
    };
  }

  loadData() {
    if (this.isFirstLoad) {
      this.isFirstLoad = false;
      this.isLoading = true;
    }
    this.jobDashboardService.getData(this.configuration).subscribe((data) => {
      this.jobData = data.map(
        (item) => new CardDataItem(item.status, item.count),
      );
      this.isLoading = false;
    });
  }
}
